<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">签约</span>
    </navbar>
    <nav class="bar-footer btn-group">
      <button class="btn btn-action" @click.stop="agree" :disabled="btnDisabled">{{btnText}}</button>
    </nav>
    <div class="page-content">
      <iframe ref="frame" :src="protocolUrl" frameborder="0" class="frame"></iframe>
    </div>
    <spinner :show="loading"></spinner>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
  </div>
</template>
<script>
  import Navbar from 'components/navbar/navbar'
  import Spinner from 'components/spinner/spinner'
  import Toast from 'components/toast/toast'

  export default {
    data () {
      return {
        loading: false,
        toastShow: false,
        toastText: '',
        btnDisabled: false,
        btnText: '同意',
        protocolUrl: ''
      }
    },
    components: {
      Navbar,
      Spinner,
      Toast
    },
    created () {
      this.orderId = this.$route.params.id
      this.token = this.$cache.getUserToken()
      this._fetchData()
    },
    methods: {
      _fetchData () {
        let vm = this
        let time = Date.now()
        this.loading = true
        this.$ajax({
          url: '/czBank/getLoanContractUrl.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time,
            sign: vm.$md5(vm.token.uid + time + vm.orderId + '1' + vm.token.mac),
            orderId: vm.orderId
          },
          done (d) {
            vm.protocolUrl = d.plugUrl + 'generic/web/viewer.html?file=' + window.decodeURIComponent(d.fileUrl)
          },
          always () {
            vm.loading = false
          }
        })
      },
      agree () {
        let vm = this
        let time = Date.now()

        this.loading = true
        this.$ajax({
          url: '/czBank/sendContractSms.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time,
            sign: vm.$md5(vm.token.uid + time + vm.orderId + '1' + vm.token.mac),
            orderId: vm.orderId
          },
          done (d, p, r) {
            vm.countdown()
            vm.$dialog({
              content: r.msg,
              onConfirm () {
                vm.showConfirm()
              }
            })
          },
          always () {
            vm.loading = false
          }
        })
      },
      countdown (t) {
        if (typeof t === 'undefined') {
          t = 60
        }
        if (--t > 0) {
          this.btnDisabled = true
          this.btnText = `${t}秒后重试`
          setTimeout(() => {
            this.countdown(t)
          }, 1000)
        } else {
          this.btnDisabled = false
          this.btnText = '重试'
        }
      },
      showConfirm () {
        let vm = this
        this.$dialog({
          type: 'prompt',
          content: '请输入验证码',
          onConfirm (e, d) {
            if (d) {
              vm.promptText = d
              vm.signAction()
            } else {
              vm.showConfirm()
            }
          }
        })
      },
      signAction () {
        let vm = this
        let time = Date.now()
        this.loading = true
        this.$ajax({
          url: '/czBank/contractByCz.jhtml',
          params: {
            uid: vm.token.uid,
            mac: vm.token.mac,
            time,
            sign: vm.$md5(vm.token.uid + time + vm.orderId + vm.promptText + '1' + vm.token.mac),
            orderId: vm.orderId,
            checkCode: vm.promptText
          },
          done (d, p, r) {
            vm.$dialog({
              content: r.msg,
              onHide () {
                vm.$router.back()
              }
            })
          },
          always () {
            vm.loading = false
          }
        })
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../../common/css/mixmin'

  .bar-footer
    display table
    setTopLine(#e2edff)
    position absolute
    bottom 0
    width 100%
    z-index 100
    background-color #fff
    box-shadow 0 -3px 20px rgba(105, 129, 165, .45)
    & ~ .page-content
      bottom px2rem(80px)
  .frame
    position absolute
    width 100%
    height 100%
    top 0
    bottom 0
    left 0
    overflow hidden

  .btn
    display table-cell
    width 100%
    height px2rem(80px)
    font-size px2rem(32px)
    border none
    border-radius 0
    letter-spacing px2rem(4)
    color #fff
    background-color #60c9c8
    &[disabled]
      opacity .5
</style>



// WEBPACK FOOTER //
// sign.vue?7d526fd3